import { render, staticRenderFns } from "./NavbarNavNotificationButton.vue?vue&type=template&id=88ca0580&scoped=true&"
import script from "./NavbarNavNotificationButton.vue?vue&type=script&lang=js&"
export * from "./NavbarNavNotificationButton.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNavNotificationButton.vue?vue&type=style&index=0&id=88ca0580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca0580",
  null
  
)

export default component.exports